import { useAppInfo } from 'AppState';
import { useNavigate } from 'react-router-dom';

export default function useHandleClientClick(){
    const {dispatchHome,dispatchMyFinancials,stateApp,dispatchApp} = useAppInfo();
    const navigate = useNavigate();
    
    const handleRoleChange = async (newRole) => {
        try {
          // Update onboarding state
          const updatedOnboarding = { ...stateApp.onboarding, userRole: newRole};
          dispatchApp({onboarding: updatedOnboarding});
          if (newRole === "consumer" && stateApp.onboarding.userRole !== "consumer"){
            navigate("/")
          }
          if (newRole === "advisor" && stateApp.onboarding.userRole !== "advisor"){
            navigate("/")
          }
        } catch (error) {
          console.error("Error updating role:", error);
        }
      };
    
    function handleClientClick(client){
        dispatchHome({clientSelected:client});
        dispatchMyFinancials({financialView:"demo",demoProfile:client});
        handleRoleChange("consumer");
        
    }
   

    return handleClientClick;
}